import type { ReactNode } from 'react'

export function DetailRow({ label, value }: { label: ReactNode; value: ReactNode }) {
  return (
    <div className="bg-muted flex items-center justify-between gap-3 rounded-lg px-3.5 py-2.5">
      <span className="text-muted-foreground text-xs font-medium">{label}</span>
      <span className="min-w-0 truncate text-xs font-semibold tabular-nums">{value}</span>
    </div>
  )
}
